import React, { useState } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { FaTrash, FaTimes, FaLock } from 'react-icons/fa';

const EmployeeDeleteModal = ({
    show,
    onHide,
    selectedEmployee,
    handleDeleteEmployee
}) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [deleting, setDeleting] = useState(false);

    const ADMIN_PASSWORD = '123456';

    const handleDelete = async () => {
        if (password !== ADMIN_PASSWORD) {
            setError('Hatalı şifre! Silme işlemi için doğru şifreyi giriniz.');
            return;
        }

        try {
            setDeleting(true);
            setError('');

            // Silme işlemi
            await handleDeleteEmployee(selectedEmployee._id);

            // Modal'ı temizle ve kapat
            setPassword('');
            setError('');
            onHide();
        } catch (error) {
            console.error('Silme hatası:', error);
            setError('Personel silinirken hata oluştu. Lütfen tekrar deneyin.');
        } finally {
            setDeleting(false);
        }
    };

    const handleClose = () => {
        if (!deleting) {
            setPassword('');
            setError('');
            onHide();
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && password) {
            handleDelete();
        }
    };

    if (!selectedEmployee) return null;

    return (
        <Modal show={show} onHide={handleClose} size="sm" centered>
            <Modal.Header closeButton className="bg-danger text-white">
                <Modal.Title>
                    <FaTrash className="me-2" />
                    Personel Arşivle
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {error && (
                    <Alert variant="danger" className="mb-3">
                        <small>{error}</small>
                    </Alert>
                )}

                <div className="mb-3">
                    <p className="text-danger mb-2">
                        <strong>DİKKAT!</strong> Bu personel arşivlenecektir.
                    </p>
                    <p className="mb-3">
                        <strong>Arşivlenecek Personel:</strong><br />
                        {selectedEmployee.personalInfo?.fullName}<br />
                        <small className="text-muted">
                            TC: {selectedEmployee.personalInfo?.tcNo}<br />
                            {selectedEmployee.workInfo?.position} - {selectedEmployee.workInfo?.department}
                        </small>
                    </p>
                </div>

                <Form.Group className="mb-3">
                    <Form.Label>
                        <FaLock className="me-2" />
                        Arşivleme işlemi için şifre giriniz:
                    </Form.Label>
                    <Form.Control
                        type="password"
                        placeholder="Şifre"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyPress={handleKeyPress}
                        disabled={deleting}
                        autoFocus
                    />
                    <Form.Text className="text-muted">
                        Bu işlem için yönetici şifresi gereklidir.
                    </Form.Text>
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                    disabled={deleting}
                    size="sm"
                >
                    <FaTimes className="me-2" />
                    İptal
                </Button>
                <Button
                    variant="danger"
                    onClick={handleDelete}
                    disabled={!password || deleting}
                    size="sm"
                >
                    {deleting ? (
                        <Spinner size="sm" animation="border" className="me-2" />
                    ) : (
                        <FaTrash className="me-2" />
                    )}
                    {deleting ? 'Arşivleniyor...' : 'Arşivle'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EmployeeDeleteModal;